import axios from 'axios'
import configurations from '../configurations'

export default axios.create({
  baseURL: configurations.WORKER
})
